"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Layout, Menu, Button, Space, Typography } from "antd";
import { useAuth } from "@/features/auth";
import { PRODUCT_NAME } from "@/shared/config/labels";

const { Header } = Layout;
const { Text } = Typography;

const navItems = [
  { key: "/features", label: "Возможности" },
  { key: "/examples", label: "Примеры" },
  { key: "/faq", label: "Вопросы и ответы" },
  { key: "/contact", label: "Контакты" },
];

export default function SiteHeader() {
  const pathname = usePathname();
  const { isAuthenticated, isSuperadmin, logout } = useAuth();

  const selectedKey = navItems.find((item) => pathname === item.key)?.key ?? "";

  return (
    <Header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
        background: "#ffffff",
        borderBottom: "1px solid #f0f0f0",
        height: 64,
      }}
    >
      <Link href="/" style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
        <span
          style={{
            display: "flex",
            height: 36,
            width: 36,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            background: "#1677ff",
            color: "#fff",
            fontWeight: 700,
            fontSize: 16,
          }}
        >
          ID
        </span>
        <Text strong style={{ fontSize: 16 }}>
          {PRODUCT_NAME}
        </Text>
      </Link>

      <Menu
        mode="horizontal"
        selectedKeys={selectedKey ? [selectedKey] : []}
        items={navItems.map((item) => ({
          key: item.key,
          label: <Link href={item.key}>{item.label}</Link>,
        }))}
        style={{ flex: 1, justifyContent: "center", border: "none", minWidth: 0, background: "transparent" }}
        disabledOverflow
      />

      <Space>
        {isAuthenticated ? (
          <>
            <Link href={isSuperadmin ? "/admin/dashboard" : "/company/dashboard"}>
              <Button>Кабинет</Button>
            </Link>
            <Button onClick={() => void logout()}>Выйти</Button>
          </>
        ) : (
          <Link href="/admin/login">
            <Button type="primary">Войти</Button>
          </Link>
        )}
      </Space>
    </Header>
  );
}
